<app-pageheader [Parent]="this">
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="permits/hotelreservations/searches"
  [AllowEdit]="true" EditUrl="/permits/hotelreservations/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-hotel-reservation-permit-type-filter></div>
    <div app-subset-filter [Subsets]="Subsets"></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>


